import type { ComponentProps } from 'react';
import { ExportPanel } from '@/features/export/ExportPanel';

type Props = ComponentProps<typeof ExportPanel> & { title: string };

/** Date-range export page: header + the shared export create/download panel. */
export const ExportFormPage = ({ title, ...panelProps }: Props) => (
  <>
    <section className="content-header">
      <h1>{title}</h1>
    </section>
    <section className="content">
      <ExportPanel {...panelProps} />
    </section>
  </>
);
